module.exports = __webpack_public_path__ + "img/deafinition_text_logo.15b5a5e0.png";